import { api } from '@/lib/api';

export const diagnosisApi = {
    orderLabTestsForBilling: (
        appointmentId: string,
        labTests: Array<{ id?: string; name?: string }>
    ) =>
        api.post(`/api/diagnosis/order-lab-tests?appointmentId=${appointmentId}`, {
            labTests,
        }),

    getByAppointment: (appointmentId: string) =>
        api.get(`/api/diagnosis/get-by-appointment/${appointmentId}`),

    updateDiagnosis: (
        appointmentId: string,
        data: {
            diagnosis: string;
            notes?: string | null;
            medicines?: unknown;
            labTests?: Array<{ id?: string; name?: string }>;
        }
    ) =>
        api.put(`/api/diagnosis/update-diagnosis?appointmentId=${appointmentId}`, data),
};
